import styled from '../../../../theme'

export const ExapanderWrapper = styled.div`
  width: auto;
  height: auto;
`
